import React from "react";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import Tooltip from "@mui/material/Tooltip";

import shortenName from "../../helpers/shorten-name";

const getActivityColumns = (type) => ([
  {
    name: "Date / Time",
    selector: "timestamp",
    sortable: true,
    cell: (row) => {
      return moment(row.timestamp).format("M/D/YY - HHmm");
    },
    minWidth: "80px",
    maxWidth: "110px",
  },
  {
    name: "Trip #",
    selector: "tripTag",
    sortable: true,
    cell: (row) => {
      return (
        <Link className="ellipsis-cell" to={`/trips/${row.tripId}`} target="_blank" rel="noopener noreferrer">
          <Tooltip title={row.tripTag} arrow>
            {row.tripTag}
          </Tooltip>
        </Link>
      );
    },
    width: "80px",
  },
  {
    name: type === "contract" ? "Client" : "Operator",
    selector: type === "contract" ? "client" : "operator",
    sortable: true,
    wrap: true,
    minWidth: "120px !important",
    width: "auto",
    cell: (row) => {
      return <div className="two-line-content">{type === "contract" ? row.client : row.operator}</div>;
    },
  },
  {
    name: "Event",
    sortable: false,
    wrap: true,
    width: "80px",
    cell: (row) => {
      const link = type === "ofr" ? `/trips/${row.tripId}?ofrId=${row._id}` : `/trips/${row.tripId}/contracts/${row._id}/preview`;

      return <Link to={link} target="_blank" rel="noopener noreferrer">{row.event}</Link>;
    },
  },
  {
    name: "Dates",
    selector: "firstDeparture",
    sortable: true,
    minWidth: "80px",
    maxWidth: "120px",
    cell: (row) => {
      if (!row.lastDeparture || moment(row.firstDeparture).format("M/D/YY") === moment(row.lastDeparture).format("M/D/YY")) {
        return moment(row.firstDeparture).format("M/D/YY");
      }

      return `${moment(row.firstDeparture).format("M/D/YY")} - ${moment(row.lastDeparture).format("M/D/YY")}`;
    },
  },
  {
    name: "Owner",
    selector: "owner",
    sortable: true,
    wrap: true,
    minWidth: "80px",
    maxWidth: "120px",
    cell: (row) => shortenName(row.owner),
  },
  {
    name: "Resolved By",
    selector: "resolvedBy",
    sortable: true,
    wrap: true,
    minWidth: "80px",
    maxWidth: "120px",
    cell: (row) => shortenName(row.resolvedBy),
  },
]);

const contractActivityColumns = getActivityColumns("contract");
const ofrActivityColumns = getActivityColumns("ofr");

export { contractActivityColumns, ofrActivityColumns };
